import { Link } from 'react-router-dom';
import { CirclePlus } from 'lucide-react';

import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';

import Loader from '@/components/common/Loader';
import { useLocations } from '@/data/location';
import LocationsTable from './components/LocationsTable';
import NotFound from '@/components/common/NotFound';

const ListPage = () => {
  const locations = useLocations();

  let content = <LocationsTable />;
  if (locations.isLoading && !locations.data) {
    content = <Loader />;
  } else if (locations.data?.length === 0) {
    content = (
      <NotFound title="No Locations Found" buttonLabel="Add a location" />
    );
  }

  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle className="flex justify-between items-center mb-4">
            Locations
            <Link to="/location/add">
              <Button variant="outline">
                <CirclePlus />
                &nbsp;Add Location
              </Button>
            </Link>
          </CardTitle>
          <CardDescription>
            Manage locations that your coaches can coach at. These locations
            should generally be the meeting location for clients and coaches.
          </CardDescription>
        </CardHeader>
        <CardContent>{content}</CardContent>
      </Card>
    </>
  );
};

export default ListPage;
